module.exports = __webpack_public_path__ + "img/00.3cf497fc.gif";